import { render, staticRenderFns } from "./ElacSharedEmptyList.vue?vue&type=template&id=36389d74"
import script from "./ElacSharedEmptyList.vue?vue&type=script&lang=js"
export * from "./ElacSharedEmptyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports